import { Component } from '@angular/core';

@Component({
  selector: 'app-campanha',
  templateUrl: './campanha.component.html',
  styleUrls: ['./campanha.component.scss']
})
export class CampanhaComponent {
  constructor() { }

  onFileSelected(event: any, campaignNumber: number) {
    const file = event.target.files[0];
    if (file) {
      // Here you would typically upload the file to your server
      // For now, we'll just create a local preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imgElement = document.querySelector(`.card:nth-child(${campaignNumber}) .card-img-top`) as HTMLImageElement;
        if (imgElement) {
          imgElement.src = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    }
  }
} 